// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jCCn","selected":"styles_selected__2pT2y"};